import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LanguageSelector } from '../language-selector';
import LOGO from '../../assets/img/deanon.png';
import s from './header.module.scss';
export const Head = ({ selectedLanguage, setSelectedLanguage }) => (_jsxs("header", { className: s.header, children: [_jsxs("div", { className: s.headerLogo, children: ["DEANON ", _jsx("img", { src: LOGO, alt: "logo" })] }), _jsx(LanguageSelector, { selectedLanguage: selectedLanguage, setSelectedLanguage: setSelectedLanguage })] }));
